import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Chip,
  Dialog,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Skeleton,
  Stack,
  SvgIcon,
  ToggleButton,
  ToggleButtonGro,
  AppBar,
  Toolbarup,
  Typography,
  Drawer,
  ToggleButtonGroup, Select, InputLabel, MenuItem,
  FormControl, Autocomplete, TextField,
  DialogContent, IconButton, Menu, ListItemIcon, useMediaQuery
} from '@mui/material';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { getApplicationApplyDetails } from 'api/application';
import ChatBotDrawer from './ChatBotDrawer';
import JopApplicationDrawer from './JopApplicationDrawer';
import UpdateReleventSkillsDrawer from './UpdateReleventSkillsDrawer';
import AutoSavingJobAppDialog from './AutoSavingJobAppDialog';
import { setApplication, saveJobApplication } from 'api/application';
import { useSnackbar } from 'components/snackbar';
import dayjs from 'dayjs';
import ExternalJob from './ExternalJob';
import ExternalJobStatus from './ExternalJobStatus';
import { getTimeDifferenceString, changeNameFormat, formatNumber, toTitleCase } from 'utils/Utils';
import ExternalJobApplicationDialog from './ExternalJobApplicationDialog';
import UnsaveCard from './UnsaveCard';
import { useAuth } from 'hooks/useAuthContext';
import StarIcon from '@mui/icons-material/Star';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { SuitableChip, ModerateChip, NotSuitableChip, CheckIcon, CrossIcon, WarningIcon } from '../icon/icon';
import ShareJob from './ShareJob';
import PDFViewer from 'components/PDFViewer';
import { createPDF } from 'utils/createPDF';
import { useTheme } from '@mui/material/styles';
import ShareIcon from '@mui/icons-material/Share';
import { downloadWordDoc, downloadBlobFile } from 'utils/Utils';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import * as pdfjs from 'pdfjs-dist';
import { useBackNavigationDialog } from 'hooks/useBackNavigationDialog';


/**
 * JobFullDetails is a React component that renders detailed information about a job application.
 * It handles various functionalities such as displaying job overview, matching skills, preferences,
 * and application details. It also allows users to apply for the job, track status, share the job,
 * and download resumes. The component makes use of various hooks to manage state and side effects,
 * and interacts with APIs to fetch and update job application data.
 *
 * Props:
 * - tab: The current tab being viewed.
 * - fetchJobPreferences: Function to fetch job preferences.
 * - application: The current job application object.
 * - onApplied: Callback function to handle actions when a job is applied.
 * - onStatusChange: Callback function to handle changes in application status.
 * - downloadResume: Function to download the resume.
 * - showExternalJobStatus: Boolean to display external job status.
 * - updateTJScore: Function to update the TJ score.
 * - handleCloseDrawer: Function to handle the closing of drawers.
 */

const JobFullDetails = ({ tab, fetchJobPreferences, application, onApplied, onStatusChange, downloadResume, showExternalJobStatus, updateTJScore, handleCloseDrawer }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { jobApply, user } = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  const { openDialog, closeDialog, dialogLocation } = useBackNavigationDialog();
  const dialogIds = dialogLocation.state?.dialogIds || [];

  const [alignment, setAlignment] = useState('job-overview');
  const [candidateDetails, setCandidateDetails] = useState({});
  const [applicationData, setApplicationData] = useState({});
  const isUploadedResume = application?.resume_data?.link  || false;
  const isDocResume = application?.resume_data?.link ? application?.resume_data?.word_link : false;
  const jobFullOverviewRef = useRef(null);
  const jobOverviewRef = useRef(null);
  // let headerRef = useRef(null);
  const jobDescRef = useRef(null);
  const jobApplicationRef = useRef(null);
  const [requirementMatchItem] = useState([
    'Offered Compensation',
    'Job Location',
    'Work Format',
    'Job Type',
    'Working Hours',
    'Notice Period',
    'Time Commitment'
  ]);

  const [matchingSkills, setMatchingSkills] = useState([]);
  // const [viewResume, setViewResume] = useState(false);
  const [nonMatchingSkills, setNonMatchingSkills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [coreMatchSkills, setCoreMatchSkills] = useState([]);

  const [showMore, setShowMore] = useState(false);

  const [resumePDF, setResumePDF] = useState(null);
  const isManualScroll = useRef(false);
  const [resumeActionAnchorEl, setResumeActionAnchorEl] = useState(null);
  const openActionMenu = Boolean(resumeActionAnchorEl);
  const [openTooltip, setOpenTooltip] = useState('');

  // const [open, setOpen] = useState(false);
  // const [openSkillsDrawer, setOpenSkillsDrawer] = useState(false);
  // const [openChatBotDrawer, setOpenChatBotDrawer] = useState(localStorage.getItem('openChatBot') === 'true' && (jobApply?.job?._id === application?._id && !(jobApply?.job?.jobDetails?.external_link)) ? jobApply?.openChatBot : false);

  // Dialog and Drawer state managed by useBackNavigationDialog
  const openJobPreference = dialogIds.includes("jobPreference");
  const openSkillsDrawer = dialogIds.includes("skillsDrawer");
  const openChatBotDrawer = dialogIds.includes("chatBotDrawer");
  // const autoSaveDialogOpen = dialogIds.includes("autoSaveDialog");
  const openExternalJob = dialogIds.includes("externalJobDialog");
  const openResumeViewer = dialogIds.includes("resumeViewer");
  const openExternalJobStatus = dialogIds.includes("openExternalJobStatus");
  const extJobAppDialogOpen = dialogIds.includes("extJobAppDialogOpen");
  const autoUnsaveDialogOpen = dialogIds.includes("UnsaveDialog");
  const shareJobDialogOpen = dialogIds.includes("shareJobDialog");

  // Handlers for all dialogs and drawers
  const handleOpenJobPreferenceDrawer = () => openDialog('jobPreference');
  const handleCloseJobPreferenceDrawer = () => closeDialog('jobPreference');
  const handleOpenSkillsDrawer = () => openDialog('skillsDrawer');
  const handleCloseSkillsDrawer = () => closeDialog('skillsDrawer');
  const handleOpenChatBotDrawer = () => openDialog('chatBotDrawer');
  const handleCloseChatBotDrawer = () => closeDialog('chatBotDrawer');
  // const handleOpenAutoSaveDialog = () => openDialog('autoSaveDialog');
  // const handleCloseAutoSaveDialog = () => closeDialog('autoSaveDialog');
  const handleOpenExternalJob = () => openDialog('externalJobDialog');
  const handleCloseExternalJob = () => closeDialog('externalJobDialog');
  const handleOpenResumeViewer = () => openDialog('resumeViewer');
  const handleCloseResumeViewer = () => closeDialog('resumeViewer');
  const handleExternalJobStatus = () => openDialog('openExternalJobStatus');
  const handleCloseExternalJobStatusDialog = (msg) => {
    closeDialog('openExternalJobStatus');
    onApplied(msg, application);
  };
  const handleOpenExtJobAppDialog = () => openDialog('extJobAppDialogOpen');
  const handleCloseExtJobAppDialog = () => closeDialog('extJobAppDialogOpen');
  const handleOpenAutoUnsaveDialog = () => openDialog('UnsaveDialog');
  const handleCloseAutoUnsaveDialog = () => closeDialog('UnsaveDialog');
  const handleOpenShareJobDialog = () => openDialog('shareJobDialog');
  const handleCloseShareJobDialog = () => closeDialog('shareJobDialog');

  /**
   * Fetches application details and updates relevant states based on the response.
   * 
   * @param {boolean} [recommend=false] - Determines if recommendations are to be included in the fetch request.
   * 
   * Retrieves application details using the job ID from the application object.
   * If the fetch is successful, updates candidate details and calculates the TJ score.
   * Depending on the application status, it updates matching skills and core skills based on 
   * either the matched requirements or the candidate's work history, certificates, and educations.
   * Also handles the display of external job status and generates a PDF buffer if applicable.
   * Logs an error if the fetch fails and sets loading state to false after the process.
   */

  const fetchData = async (recommend = false) => {
    try {
      // console.log(application?.resume_data);
      const response = await getApplicationApplyDetails({ id: application?.job_id, recommend: recommend });
      if (response?.success && response?.data != null) {
        setCandidateDetails(response?.data);
        const TjScore = response?.data?.aggregateScore;

        console.log('Rating:', response?.data?.rating)
        console.log('TjScore:', response?.data?.aggregateScore);

        if ((application?.status === 'saved' || application?.status === 'application pending') && (recommend || (application?.tj_score !== TjScore))) {
          updateTJScore(TjScore);
          application.tj_score = TjScore;
        }
        if (application?.status !== 'saved' && application?.status !== 'application pending') {
          setMatchingSkills(application?.requirements_matched?.matching_skills || []);
          setCoreMatchSkills(application?.requirements_matched?.core_skills || []);
        } else {
          setMatchingSkills(
            handleMatchingSkills(
              response?.data?.workHistory || [],
              response?.data?.certificate || [],
              response?.data?.educations || [],
              application?.jobDetails?.key_skills || [],
              application?.jobDetails?.core_skills || []
            )
          );
        }
        if (showExternalJobStatus === 'showExternalStatus') {
          handleExternalJobStatus();
        }
        generatePdfBuffer();
      } else {
        console.error('Failed to fetch job info:', response?.data?.message);
      }
    } catch (error) {
      console.error('Error fetching job info:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setAlignment('job-overview');
    setLoading(true);
    setApplicationData(application);
    fetchData();
  }, [application]);

  const handleScroll = useCallback(() => {
    if (isManualScroll.current || !jobFullOverviewRef.current) return;

    const container = jobFullOverviewRef.current;
    const scrollPosition = container.scrollTop;

    const sections = [
      { id: "job-overview", ref: jobOverviewRef },
      { id: "job-desc", ref: jobDescRef },
      { id: "job-application", ref: jobApplicationRef },
    ];

    for (const section of sections) {
      if (!section.ref.current) continue;

      const rect = section.ref.current.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      const isVisible =
        rect.top >= containerRect.top &&
        rect.bottom <= containerRect.bottom;

      if (isVisible) {
        if (alignment !== section.id) {
          setAlignment(section.id);
        }
        break;
      }
    }
  }, [alignment]);

  useEffect(() => {

    const container = jobFullOverviewRef.current;
    if (!container) return;

    container.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll, loading]);
  // useEffect(() => {
  //   if (isMobile) {
  //     localStorage.setItem('tabValue', tab);
  //     if (openChatBotDrawer) {
  //       localStorage.setItem('job', JSON.stringify(application));
  //     } else {
  //       localStorage.removeItem('job');
  //     }
  //   }
  // }, [openChatBotDrawer]);

  /**
   * Checks if the candidate matches the job requirements in a given field.
   * @param {Object} job - The job object.
   * @param {Object} candidate - The candidate object.
   * @param {string} title - The field to check. One of 'Qualification', 'Experience', 'Skills', or 'Industry'.
   * @returns {React.ReactElement} - An icon indicating whether the candidate matches the requirement.
   *   - A <CheckIcon /> if the candidate matches the requirement.
   *   - A <WarningIcon /> if the candidate partially matches the requirement.
   *   - A <CrossIcon /> if the candidate does not match the requirement.
   */
  const requirementsMatch = (job, candidate, title) => {
    let match = 1;
    if (title === 'Qualification') match = candidate === 4 ? 3 : 1;
    if (title === 'Experience' || title === 'Skills') match = candidate === 4 ? 3 : candidate;
    if (title === 'Industry') match = candidate === 4 ? 3 : 2;

    if (match === 3) {
      return (
        <CheckIcon />
      )
    } else if (match === 2) {
      return (
        <WarningIcon />
      )
    } else {
      return (
        <CrossIcon />
      )
    }
  };

  /**
   * Toggles the drawer open or closed.
   * @param {boolean} newOpen - The desired state of the drawer.
   * @returns {function} - A function that can be called to toggle the drawer.
   */
  // const toggleDrawer = (newOpen) => () => {
  //   setOpen(newOpen);
  // };



  /**
   * A higher-order function that takes a boolean and returns a function that
   * toggles the state of the skills drawer to that boolean value.
   * @param {boolean} newOpenSkills - The desired state of the skills drawer.
   * @returns {function} - A function that takes no arguments and toggles the drawer
   */
  // const toggleSkillsDrawer = (newOpenSkills) => () => {
  //   setOpenSkillsDrawer(newOpenSkills);
  // };

  /**
   * A higher-order function that takes a boolean and returns a function that
   * toggles the state of the chat bot drawer to that boolean value.
   * @param {boolean} newOpenSkills - The desired state of the chat bot drawer.
   * @returns {function} - A function that takes no arguments and toggles the drawer
   */
  const toggleChatBotDrawer = (newOpenSkills) => () => {
    // setOpenChatBotDrawer(newOpenSkills);
    newOpenSkills ? handleOpenChatBotDrawer() : handleCloseChatBotDrawer();
  };

  const [autoSaveDialogOpen, setAutoSetDialogOpen] = useState(false);
  /**
   * Closes the auto-save dialog.
   * @returns {void}
   */

  const handleCloseAutoSaveDialog = () => {
    setAutoSetDialogOpen(false);
  };

  /**
   * Handles changes to the ToggleButtonGroup.
   * When the toggle value changes, it updates the state with the new alignment
   * and scrolls smoothly to the corresponding section in the job details.
   * @param {React.ChangeEvent<HTMLInputElement>} event - The event from the ToggleButtonGroup.
   * @param {string} newAlignment - The new alignment value from the ToggleButtonGroup.
   */

  const handleToggleChange = (event, newAlignment) => {
    isManualScroll.current = true;
    if (newAlignment !== null) {
      setAlignment(newAlignment);
      let targetRef;

      switch (newAlignment) {
        case 'job-overview':
          targetRef = jobOverviewRef;
          break;
        case 'job-desc':
          targetRef = jobDescRef;
          break;
        case 'job-application':
          targetRef = jobApplicationRef;
          break;
        default:
          break;
      }

      jobFullOverviewRef.current.scrollTo({
        top: targetRef.current.offsetTop,
        block: 'start',
        behavior: 'smooth',
      });

      setTimeout(() => {
        isManualScroll.current = false;
      }, 500);
    }
  };

  /**
   * Returns a React component displaying an icon and title indicating the match status
   * between a job and a candidate based on the given title.
   * 
   * @param {Object} job - The job object.
   * @param {number} candidate - The candidate's matching level.
   * @param {string} title - The title to display, such as 'Offered Compensation'.
   * @returns {React.ReactElement} A React element containing an icon that represents 
   * the match status (CheckIcon, WarningIcon, or CrossIcon) and the title.
   *   - CheckIcon for a perfect match.
   *   - WarningIcon for a partial match.
   *   - CrossIcon for no match.
   */

  const matchIcon = (job, candidate, title) => {
    let match = 1;

    if (title === 'Offered Compensation') {
      if (!job) return (
        <Box>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Box className="off-comp-rupees" sx={{ fontFamily: 'Inter, sans-serif!important' }}>
              ₹
            </Box>
            <Typography className="pref-match-title">{title || 'NA'}</Typography>
          </Stack>
        </Box>
      );
      match = candidate === 4 ? 3 : candidate;
    } else {
      match = candidate === 2 ? 3 : 1;
    }

    const IconComponent = match === 3 ? CheckIcon : match === 2 ? WarningIcon : CrossIcon;

    return (
      <Box>
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <IconComponent />
          <Typography className="pref-match-title">{title || 'NA'}</Typography>
        </Stack>
      </Box>
    );
  };

  /**
   * Compares and analyzes candidate's skills against job requirements and core skills.
   * 
   * This function processes the candidate's work history, certificates, and education
   * to extract skills, normalizes them, and compares them with the required job skills 
   * and core skills. It identifies matching skills, non-matching skills, and core skills
   * that match.
   * 
   * @param {object[]} workHistory - Array of objects representing the candidate's work history,
   *                                 each containing a skills property.
   * @param {object[]} certificate - Array of objects representing the candidate's certificates,
   *                                 each containing a skills property.
   * @param {object[]} education - Array of objects representing the candidate's education,
   *                               each containing a skills property.
   * @param {string[]} jobSkills - Array of strings representing the skills required for the job.
   * @param {string[]} coreSkills - Array of strings representing the core skills required for the job.
   * @returns {string[]} - An array of strings representing matching skills between the candidate
   *                       and the job requirements.
   */

  const handleMatchingSkills = (workHistory, certificate, education, jobSkills, coreSkills) => {
    if (!workHistory || !Array.isArray(workHistory)) {
      console.error('Invalid work history provided.');
      return [];
    }
    if (!jobSkills || !Array.isArray(jobSkills)) {
      console.error('Invalid job skills provided.');
      return [];
    }
    let candidateSkills = [];
    workHistory?.forEach((history) => {
      if (history?.skills && Array.isArray(history?.skills)) {
        candidateSkills.push(...history.skills.map((skill) => skill.toLowerCase()));
      } else {
        console.warn('Invalid or missing skills property in work history entry:', history);
      }
    });
    certificate?.forEach((history) => {
      if (history?.skills && Array.isArray(history?.skills)) {
        candidateSkills.push(...history.skills.map((skill) => skill.toLowerCase()));
      } else {
        console.warn('Invalid or missing skills property in work history entry:', history);
      }
    });
    education?.forEach((history) => {
      if (history?.skills && Array.isArray(history?.skills)) {
        candidateSkills.push(...history.skills.map((skill) => skill.toLowerCase()));
      } else {
        console.warn('Invalid or missing skills property in work history entry:', history);
      }
    });
    const uniqueCandidateSkills = [...new Set(candidateSkills)];
    const matchingSkills = [];
    const nonMatchingSkills = [];
    jobSkills?.forEach((skill) => {
      const lowerCaseSkill = skill.toLowerCase();
      if (uniqueCandidateSkills?.includes(lowerCaseSkill)) {
        matchingSkills.push(skill);
      } else {
        nonMatchingSkills.push({ skill, is_core: coreSkills?.includes(skill) });
      }
    });
    let coreMatchSkill = [];

    coreSkills?.forEach((skill) => {
      const lowerCaseSkill = skill.toLowerCase();
      if (uniqueCandidateSkills?.includes(lowerCaseSkill)) {
        coreMatchSkill.push(skill);
      }
    });
    setCoreMatchSkills(coreMatchSkill);
    setNonMatchingSkills(nonMatchingSkills);
    return matchingSkills;
  };

  /**
   * Handles the update of job preferences by fetching updated data.
   * This function asynchronously calls fetchData with a recommendation flag
   * set to true, ensuring the latest job preference data is retrieved.
   * Intended to refresh job-related information based on updated preferences.
   * @returns {Promise<void>}
   */

  const handleUpdatePreference = async () => {
    await fetchData(true);
  };

  /**
   * Handles the selected resume for the job application.
   * Closes the chat bot drawer and refetches the job details with the selected resume.
   * @param {object} resume - The selected resume for the job application.
   */
  const handleSelectedResume = (resume) => {
    toggleChatBotDrawer(false);
    handleRefetchJob();
  };
  // const [shareJobDialogOpen, setShareJobDialogOpen] = useState(false);
  /**
   * Opens the share job dialog and closes the resume action menu.
   */
  // const handleOpenShareJobDialog = () => {
  //   setShareJobDialogOpen(true);
  //   setResumeActionAnchorEl(null);
  // };
  /**
   * Closes the share job dialog box.
   */
  // const handleCloseShareJobDialog = () => {
  //   setShareJobDialogOpen(false);
  // };

  /**
   * Closes the resume preview dialog box.
   */
  // const handleCloseResume = () => {
  //   setViewResume(false);
  // };

  /**
   * Updates the skills for the job application.
   * Triggers a data fetch to refresh job details with the updated skills.
   * @param {Object} skills - The skills object containing updated skills information.
   */

  const handleSkillsUpdate = (skills) => {
    fetchData(true);
  };

  /**
   * Triggers a data fetch to refresh job details with the updated skills
   * when non-matching skills are provided.
   * @param {Object} skills - The skills object containing updated skills information.
   */
  const handleNonMatchingSkills = (skills) => {
    fetchData();
  };

  const recommendedChip = (score) => score >= 3 ? <SuitableChip /> : score >= 2 ? <ModerateChip /> : <NotSuitableChip />;

  // const [openExternalJob, setOpenExternalJob] = useState((jobApply?.job?._id === application?._id && jobApply?.job?.jobDetails?.external_link) ? jobApply?.openChatBot : false);
  /**
   * Handles the job application process.
   * Opens an external job dialog if the job has an external link,
   * otherwise opens the chat bot drawer to continue the application process.
   */

  const handleApplyJob = () => {
    if (application?.jobDetails?.external_link) {
      // setOpenExternalJob(true);
      handleOpenExternalJob();
    } else {
      // setOpenChatBotDrawer(true);
      handleOpenChatBotDrawer();
    }
  };
  /**
   * Closes the external job dialog box.
   */
  const handleCloseExternalJobDialog = (val) => {
    // setOpenExternalJob(false);
    handleCloseExternalJob();
    if (val === 'open External Job Dialog') setOpenConfirmationDialog(true);
  };

  // const [openExternalJobStatus, setOpenExternalJobStatus] = useState(false);
  /**
   * Opens the external job status dialog.
   * This function sets the state to open the dialog which displays the status
   * of an external job application, allowing the user to view and track their
   * application progress.
   */

  // const handleExternalJobStatus = () => {
  //   setOpenExternalJobStatus(true);
  // };
  /**
   * Handles the close of the external job status dialog.
   * If the msg is equal to 'applied', reloads the job details.
   * @param {string} msg - The message from the dialog.
   */
  // const handleCloseExternalJobStatusDialog = (msg) => {
  //   setOpenExternalJobStatus(false);
  //   onApplied(msg, application);
  // };
  /**
   * Handles the download of the resume for the job application.
   * It creates a data object with the job, candidate details, matching skills
   * and the tab, and calls the downloadResume function with this object.
   * After the download is complete, it closes the external job dialog.
   */
  const handleDownloadResume = () => {
    const dataForExternalJob = { job: application, candidateDetails: candidateDetails, matchingSkills: matchingSkills, tab: '3' };
    downloadResume(dataForExternalJob);
    handleCloseExternalJobDialog();
    handleCloseExtJobAppDialog();
  };

  /**
   * Handles the click of the "Track Status" button in the external job dialog.
   * Opens the external link of the job application in a new tab.
   */
  const handleTackStatusButton = () => {
    window.open(application?.jobDetails?.external_link);
  };

  /**
   * Asynchronously handles the change of application status.
   * 
   * This function retrieves the new status from the event, updates the
   * application status via an API call, and triggers notifications based
   * on the success or failure of the operation.
   * 
   * If the status update is successful, it updates the application data
   * and triggers the onStatusChange callback with the new data.
   * 
   * @param {object} event - The event object from the status change action.
   */

  const handleStatusChange = async (event) => {
    const status = event.target.value;
    const response = await setApplication({ status, jobId: application?.job_id, isStatusChange: true })
    if (response?.success && response.data) {
      setApplicationData(response?.data)
      onStatusChange(response?.data)
      enqueueSnackbar('Successfully updated the application status', { variant: 'success' });
    } else {
      enqueueSnackbar('Failed to update the application status. Please try again.', { variant: 'error' });
    }
  }

  // const [extJobAppDialogOpen, setExpJobAppDialogOpen] = useState(false);

  /**
   * Opens the external job application dialog.
   * This dialog is used to display the status of an external job application,
   * allowing the user to view and track their application progress.
   */
  const hadleOpenExtJobAppDialog = () => {
    // setExpJobAppDialogOpen(true);
    handleOpenExtJobAppDialog();
  };
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  useEffect(() => {
    if (jobApply?.job?._id === application?._id || jobApply?.openChatBot) {
      if (jobApply?.job?.jobDetails?.external_link) handleOpenExternalJob();
      else handleOpenChatBotDrawer();
    } else {
      handleCloseChatBotDrawer();
    }
  }, []);

  useEffect(() => {
    if (openConfirmationDialog && !openExternalJob && !extJobAppDialogOpen) {

      const timer = setTimeout(() => {
        handleExternalJobStatus();
        setOpenConfirmationDialog(false);
      }, 500); // or 100ms if needed

      return () => clearTimeout(timer);
    }
  }, [openConfirmationDialog, openExternalJob, extJobAppDialogOpen]);


  /**
   * Closes the external job application dialog.
   * This function is called when the user closes the dialog
   * without performing any actions.
   */
  const handleCloseExtJopAppDialog = (val) => {
    // setExpJobAppDialogOpen(false);
    handleCloseExtJobAppDialog();
    if (val === 'open External Job Dialog') setOpenConfirmationDialog(true);
  };

  /**
   * Handles the refetching of the job data.
   * This function is called when the user clicks on the "Refresh" button
   * in the job details dialog. It triggers the onApplied callback to refetch
   * the job data from the server.
   */
  const handleRefetchJob = () => {
    onApplied();
  };

  // const [autoUnsaveDialogOpen, setAutoUnsaveDialogOpen] = useState(false);
  /**
   * Opens the "Auto Unsave Job" dialog.
   * This dialog is used to confirm with the user if they want to automatically unsave the job application
   * when they update their resume while applying to a job. It provides options to continue or cancel the process.
   */
  // const handleOpenAutoUnsaveDialog = () => {
  //   setAutoUnsaveDialogOpen(true);
  // };
  /**
   * Closes the "Auto Unsave Job" dialog.
   * Sets the autoUnsaveDialogOpen state to false to close the dialog.
   */

  // const handleCloseAutoUnsaveDialog = () => {
  //   setAutoUnsaveDialogOpen(false);
  // };

  /**
   * Handles unsaving a job application for later.
   * Calls the saveJobApplication API to set the job status to 'unsaved'.
   * If the API call is successful, updates the application status, refetches the job data, and closes the "Auto Unsave Job" dialog.
   * If the API call fails, shows an error snackbar.
   * Logs any errors to the console.
   */
  const handleUnsaveJob = async () => {
    try {
      const response = await saveJobApplication({ jobId: application?.job_id, companyId: application?.jobDetails?.company_id, type: 'unsaved' });
      if (response?.success) {
        application.status = 'unsaved';
        handleRefetchJob();
        handleCloseAutoUnsaveDialog();
      } else {
        enqueueSnackbar('Failed to Unsave the application. Please try again.', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error unsaving for later:', error);
    }
  };

  /**
   * Extracts the unique industry type(s) from the given work history items.
   * @param {Object[]} work Work history items.
   * @returns {string[]} Unique industry type(s) as strings.
   */
  const handleIndustryType = (work) => {
    const industryType = [];
    work?.forEach((item) => {
      const sector = item?.organization_details?.industry_sector;
      if (sector) industryType.push(sector);
    });
    const uniqueIndustryType = [...new Set(industryType)];
    return uniqueIndustryType;
  };
  /**
   * Returns a message describing the candidate's industry experience.
   * If the candidate has work history with an industry, returns a message listing the industries.
   * Otherwise, returns a message indicating that there are no industries associated with the candidate's work experiences.
   * @returns {string} The message describing the candidate's industry experience.
   */
  const industryMessage = () => {
    const industryType = handleIndustryType(candidateDetails?.workHistory);
    if (industryType?.length > 0) return `Your experiance is in following industry: ${industryType?.join(', ')}`;
    else return `There are no industries associated with your work experiences`;
  };

  /**
   * Asynchronously generates a PDF buffer from the user's profile and resume data.
   * The function utilizes the `createPDF` utility to assemble the PDF with various 
   * sections such as education, work experience, certifications, custom sections, 
   * and summaries. Once the PDF buffer is created, it is converted to a blob and 
   * stored in the state for further use. If an error occurs during the process, 
   * it is logged to the console.
   */

  const generatePdfBuffer = async () => {
    try {
      const buffer = await createPDF({
        profile: user,
        educationData: reorderEducation(application?.resume_data?.educations || []),
        workExperienceData: reorderWorkHistory(application?.resume_data?.work_history || []),
        certificateData: reorderCertification(application?.resume_data?.certificates || []),
        customSection: application?.resume_data?.custom_section || [],
        summaryData: application?.resume_data?.summary || '',
        financeTechologiesData: application?.resume_data?.finance_technologies || []
      });
      const blob = new Blob([buffer], { type: 'application/pdf' });
      setResumePDF(blob);
    } catch (e) {
      console.error(e);
    }
  };

  /**
   * Downloads the resume as a Word document using the given data.
   * @throws {Error} If there is an error downloading the Word document.
   */
  const handleDownloadWordResume = async () => {
    try {
      const { educations, work_history, certificates, finance_technologies, summary, custom_section, title } = application?.resume_data;
      if (application?.resume_data?.word_link) {
        await downloadDocx(application?.resume_data?.word_link);
      } else {
        await downloadWordDoc([
          user.photo || user.profile_pic, user, {
            user: user,
            educations: educations ? reorderEducation(educations) : [],
            experiences: work_history ? reorderWorkHistory(work_history) : [],
            certifications: certificates ? reorderCertification(certificates) : [],
            customSection: custom_section ?? [],
            professional: summary ?? '',
            technicalCompetencies: finance_technologies ?? []
          }]);
      }
    } catch (error) {
      enqueueSnackbar('Error downloading Word document', { variant: 'error' });
      console.error("Error downloading Word document:", error);
    }
  };

  const downloadDocx = async (fileUrl) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_END_POINT}${fileUrl}`);

      if (!response.ok) throw new Error('Failed to download');

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const extension = fileUrl.endsWith('.docx') ? 'docx' : 'doc';

      const link = document.createElement('a');
      link.href = url;
      link.download = `${user.name.trim()} (Uploaded Resume).${extension}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download error:', err);
    }
  };

  /**
   * Downloads the resume as a PDF using the given data.
   * If the resumePDF state is populated, this function will call the downloadBlobFile utility to download the PDF.
   * The filename will be constructed using the user's name and the resume title, separated by a hyphen.
   * @returns {void}
   */
  const handlePDFDownloadResume = () => {
    if (resumePDF) downloadBlobFile(resumePDF, `${user?.name?.toLowerCase()?.trim()?.replace(' ', '-')}-${(application?.resume_data?.title || "master-resume")?.toLowerCase()?.trim()?.replace(" ", "-")}.pdf`)
  };

  /**
   * Sorts the given education list in descending order of the education end date.
   * @param {Object[]} educationList - The education list to sort.
   * @returns {Object[]} The sorted education list.
   */
  const reorderCertification = (educationList) => {
    if (educationList?.length === 0) return [];
    educationList.sort((a, b) => new Date(b.education_to) - new Date(a.education_to));
    return educationList;
  }

  /**
   * Sorts the given education list in descending order of the education start date.
   * @param {Object[]} educationList - The education list to sort.
   * @returns {Object[]} The sorted education list.
   */
  const reorderEducation = (educationList) => {
    if (educationList?.length === 0) return [];
    educationList.sort((a, b) => new Date(b.education_from) - new Date(a.education_from));
    return educationList;
  }

  /**
   * Sorts the given work history list in descending order of the job end date.
   * If the given job has a 'present' property set to true, it will be placed first
   * in the sorted list. If there are multiple jobs with this property set to true,
   * they will be sorted in descending order of their 'work_history_to' date.
   * The remaining jobs will be sorted in descending order of their 'work_history_from' date.
   * @param {Object[]} workHistory - The work history list to sort.
   * @returns {Object[]} The sorted work history list.
   */
  const reorderWorkHistory = (workHistory) => {
    if (workHistory?.length === 0) return [];
    const presentJobs = workHistory.filter(job => job.present);
    const otherJobs = workHistory.filter(job => !job.present);

    const maxWorkHistoryToJob = otherJobs.reduce((maxJob, job) => {
      const jobDate = new Date(job.work_history_to || 0);
      const maxJobDate = maxJob ? new Date(maxJob.work_history_to || 0) : new Date(0);
      return jobDate > maxJobDate ? job : maxJob;
    }, null);

    const remainingJobs = otherJobs.filter(job => job !== maxWorkHistoryToJob);

    remainingJobs.sort((a, b) => new Date(b.work_history_from) - new Date(a.work_history_from));

    return [
      ...presentJobs,
      ...(maxWorkHistoryToJob ? [maxWorkHistoryToJob] : []),
      ...remainingJobs,
    ];
  };

  /**
   * Calculates the percentage of a part relative to its whole.
   *
   * This function takes two arguments, `num` and `den`, which represent
   * the numerator and denominator of a fraction. It computes the percentage
   * by dividing `num` by `den`, multiplying by 100, and rounding the result
   * to the nearest whole number.
   *
   * @param {number} num - The numerator or part value.
   * @param {number} den - The denominator or whole value.
   * @returns {number} - The calculated percentage.
   */

  const percentage = (num, den) => {
    const per = Math.round((num / den) * 100)
    return per;
  };

  /**
   * Generates a salary message comparing the candidate's expected and offered compensation.
   *
   * This function compares the offered salary against the candidate's expected salary
   * based on job type and salary rating. It returns a message indicating whether the offer
   * is higher, lower, or similar to the candidate's expectations. It also includes tooltips
   * for detailed compensation information.
   *
   * @param {number} salaryRating - Rating of the salary offer (e.g., 2 for close match).
   * @param {Object} jobPreference - Candidate's job preferences containing salary expectations.
   * @param {number} salary - The salary offered by the employer.
   * @param {string} jobType - Type of job being offered, e.g., 'Full time'.
   * @returns {JSX.Element} - A message JSX element with salary comparison information and tooltips.
   */

  const salaryMessage = (salaryRating, jobPreference, salary, jobType) => {
    const isFullTime = jobType === 'Full time';
    const candidateSalary = parseInt(
      isFullTime ? jobPreference?.total_ctc || 0 : jobPreference?.hourly_rate || 0
    );
    const offeredSalary = parseInt(salary || 0);

    /**
     * Renders a tooltip with the candidate's compensation information.
     *
     * This function takes a string text parameter and returns a JSX element
     * containing a tooltip with the candidate's compensation information.
     * The tooltip is triggered by clicking on the rendered text, and it
     * is only displayed if the user is on a mobile device and the
     * openTooltip state is set to 'salary'.
     *
     * @param {string} text - The text to render with the tooltip.
     * @returns {JSX.Element} - The rendered JSX element with the tooltip.
     */
    const renderTooltip = (text) => (
      <Tooltip
        title={`Your compensation is ₹${formatNumber(candidateSalary)}`}
        arrow
        placement="top"
        open={(isMobile && openTooltip === 'salary') ? openTooltip : undefined}
      >
        <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleToggleTooltip('salary')}>
          {text}
        </span>
      </Tooltip>
    );
    /**
     * Renders a tooltip with the candidate's compensation information.
     *
     * This function takes a string text parameter and returns a JSX element
     * containing a tooltip with the candidate's compensation information.
     * The tooltip is triggered by clicking on the rendered text, and it
     * is only displayed if the user is on a mobile device and the
     * openTooltip state is set to 'salary'.
     *
     * @param {string} text - The text to render with the tooltip.
     * @returns {JSX.Element} - The rendered JSX element with the tooltip.
     */
    const partTimeTooltip = (text) => (
      <Tooltip
        title={`Your compensation is ₹${candidateSalary} per hour`}
        arrow
        placement="top"
        open={(isMobile && openTooltip === 'salary') ? openTooltip : undefined}
      >
        <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleToggleTooltip('salary')}>
          {text}
        </span>
      </Tooltip>
    );

    if (isFullTime) {
      if (salaryRating === 2) {
        const message = offeredSalary > candidateSalary
          ? 'May be out of range versus '
          : 'No significant increment versus ';
        return (
          <>
            {message}
            {renderTooltip('current compensation')}. Please evaluate.
          </>
        );
      }

      const message = offeredSalary > candidateSalary
        ? 'Much higher than '
        : 'Lower than ';
      return (
        <>
          {message}
          {renderTooltip('current compensation')}.
        </>
      );
    }

    // Part-time logic
    if (salaryRating === 2) {
      const message = offeredSalary > candidateSalary
        ? 'Offered rate quite above '
        : 'Offered rate quite below ';
      return (
        (application?.jobDetails?.compensation_model === 'per hour' ? <>
          {message}
          {partTimeTooltip('desired compensation')}. Please evaluate.
        </> : <>
          This project offers a {partTimeTooltip('fixed fee')}. Please evaluate.</>)
      );
    }

    return (
      application?.jobDetails?.compensation_model === 'per hour' ? <>
        Offered rate well below {partTimeTooltip('desired compensation')}. Please evaluate.
      </> : <>
        This project offers a {partTimeTooltip('fixed fee')}. Please evaluate.</>
    );
  };

  /**
   * Handles toggling of the tooltip for mobile devices.
   * If on a mobile device, it sets the openTooltip state to the given title and
   * then sets it back to an empty string after 5 seconds.
   * @param {string} title - The title of the tooltip to toggle.
   */
  const handleToggleTooltip = (title) => {
    if (isMobile) {
      setOpenTooltip(title);
      setTimeout(() => setOpenTooltip(''), 5000);
    }
  };

  /**
   * Downloads the uploaded resume for the job application.
   * If the file URL or the user's name is missing, it logs an error to the console.
   * If the file can be downloaded, it creates a link element and clicks it to
   * download the file. The file is named as the user's name plus "(Uploaded Resume).pdf"
   * and is removed from the DOM after download.
   * If the download fails, it logs an error to the console.
   */
  const handleDownloadUploadedResume = async () => {
    if (!isUploadedResume || !user?.name) {
      console.error("File URL is missing");
      return;
    }
    try {
      const response = await fetch(`${process.env.REACT_APP_END_POINT}${isUploadedResume}`);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const formattedFileName = `${user.name.trim()} (Uploaded Resume).pdf`;
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", formattedFileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const expectedCtc = parseInt(candidateDetails?.user?.candidate?.job_preferences?.expected_ctc, 10);
  const jobCompensation = parseInt(application?.jobDetails?.salary, 10);
  const comparisonText = expectedCtc > jobCompensation ? 'Less' : 'Greater';
  const truncatedDescription = showMore ? application?.jobDetails?.job_overview : application?.jobDetails?.job_overview.substring(0, 50) + (application?.jobDetails?.job_overview.length > 50 ? '...' : '');

  return (
    <Box className="job-full-details">
      {/* header block */}
      <Box className="job-full-details-header">
        <Box className="header-top">
          <Stack direction="row" justifyContent={'space-between'} spacing={2}>
            <Box>
              <Typography className="title">{application?.jobDetails?.title || 'N/A'}</Typography>
              <Stack direction="row" alignItems={'center'} spacing={1}>
                {application?.jobDetails?.is_company_name_confidential ? <Typography className="company-name">Company Name - Confidential</Typography> : <Typography className="company-name">{application?.jobDetails?.company || ''}</Typography>}
                <Divider orientation="vertical" variant="middle" flexItem sx={{ backgroundColor: '#a5a297' }} />
                <Typography className="city-name">{application?.jobDetails?.location || 'N/A'}</Typography>
                <Divider orientation="vertical" variant="middle" flexItem sx={{ backgroundColor: '#a5a297' }} />
                <Typography className="city-name">{application?.jobDetails?.job_type || 'N/A'}</Typography>
              </Stack>
            </Box>

            {loading ? (
              <Stack direction="row" spacing={3}>
                <Skeleton height={60} width="100%" />
              </Stack>
            ) : (
              <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <Stack direction="row" alignItems={'center'} spacing={3}>
                  {application?.status === 'saved' && (
                    <Button
                      variant="outlined"
                      size="large"
                      className="saved-btn"
                      onClick={handleOpenAutoUnsaveDialog}
                      sx={{ width: '150px' }}
                      startIcon={
                        <SvgIcon>
                          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.77869 1.3764L3.45821 5.69687C3.16468 5.99041 2.67851 5.99041 2.3758 5.69687L0.220152 3.54122C-0.0733838 3.24769 -0.0733838 2.76152 0.220152 2.45881C0.513687 2.16527 0.999855 2.16527 1.30256 2.45881L2.92618 4.08243L6.70545 0.303159C6.99898 0.00962395 7.48515 0.00962395 7.78786 0.303159C8.07222 0.596695 8.07222 1.08286 7.77869 1.3764Z" fill="white" />
                          </svg>
                        </SvgIcon>
                      }
                    >
                      Job Saved
                    </Button>
                  )}
                  {(application?.status === 'saved' || application?.status === 'application pending') ? (
                    <Button sx={{ width: '150px' }}
                      variant="outlined"
                      size="large"
                      className={application?.jobDetails?.external_link ? "external-apply-now-btn" : "apply-now-btn"}
                      endIcon={application?.jobDetails?.external_link ? < SvgIcon >
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5413 0.0581763C15.7159 0.130897 15.8613 0.276338 15.934 0.450867H15.9413C15.9776 0.538131 15.9995 0.632668 15.9995 0.727205V5.03953C15.9995 5.43949 15.6722 5.76673 15.2723 5.76673C14.8723 5.76673 14.5451 5.43949 14.5451 5.03953V2.47977L8.51653 8.50829C8.37109 8.64646 8.18929 8.71918 8.00021 8.71918C7.81114 8.71918 7.62934 8.65373 7.4839 8.50829C7.20029 8.22468 7.20029 7.76654 7.4839 7.48293L13.5124 1.45441H10.9527C10.5527 1.45441 10.2255 1.12717 10.2255 0.727205C10.2255 0.327242 10.5527 0 10.9527 0H15.265C15.3595 0 15.4541 0.0218161 15.5413 0.0581763ZM14.5375 8.0013C14.5375 7.60134 14.8648 7.27409 15.2648 7.27409C15.6647 7.27409 15.992 7.60134 15.992 8.0013V13.0554C15.992 14.677 14.6684 16.0005 13.0468 16.0005H2.94591C1.32424 16.0005 0.000732422 14.677 0.000732422 13.0554V2.9545C0.000732422 1.33283 1.32424 0.00932173 2.94591 0.00932173H7.99998C8.39994 0.00932173 8.72719 0.336564 8.72719 0.736526C8.72719 1.13649 8.39994 1.46373 7.99998 1.46373H2.94591C2.12417 1.46373 1.45514 2.13276 1.45514 2.9545V13.0554C1.45514 13.8771 2.12417 14.5461 2.94591 14.5461H13.0468C13.8685 14.5461 14.5375 13.8771 14.5375 13.0554V8.0013Z" fill="white" />
                        </svg>
                      </SvgIcon> : null}
                      onClick={handleApplyJob}
                    >
                      Apply Now
                    </Button>
                  ) : (
                    application?.is_external_job_application &&
                    <Button sx={{ width: '150px' }} variant="outlined" size="large" className="external-apply-now-btn" endIcon={<SvgIcon>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5413 0.0581763C15.7159 0.130897 15.8613 0.276338 15.934 0.450867H15.9413C15.9776 0.538131 15.9995 0.632668 15.9995 0.727205V5.03953C15.9995 5.43949 15.6722 5.76673 15.2723 5.76673C14.8723 5.76673 14.5451 5.43949 14.5451 5.03953V2.47977L8.51653 8.50829C8.37109 8.64646 8.18929 8.71918 8.00021 8.71918C7.81114 8.71918 7.62934 8.65373 7.4839 8.50829C7.20029 8.22468 7.20029 7.76654 7.4839 7.48293L13.5124 1.45441H10.9527C10.5527 1.45441 10.2255 1.12717 10.2255 0.727205C10.2255 0.327242 10.5527 0 10.9527 0H15.265C15.3595 0 15.4541 0.0218161 15.5413 0.0581763ZM14.5375 8.0013C14.5375 7.60134 14.8648 7.27409 15.2648 7.27409C15.6647 7.27409 15.992 7.60134 15.992 8.0013V13.0554C15.992 14.677 14.6684 16.0005 13.0468 16.0005H2.94591C1.32424 16.0005 0.000732422 14.677 0.000732422 13.0554V2.9545C0.000732422 1.33283 1.32424 0.00932173 2.94591 0.00932173H7.99998C8.39994 0.00932173 8.72719 0.336564 8.72719 0.736526C8.72719 1.13649 8.39994 1.46373 7.99998 1.46373H2.94591C2.12417 1.46373 1.45514 2.13276 1.45514 2.9545V13.0554C1.45514 13.8771 2.12417 14.5461 2.94591 14.5461H13.0468C13.8685 14.5461 14.5375 13.8771 14.5375 13.0554V8.0013Z" fill="white" />
                      </svg>
                    </SvgIcon>}
                      onClick={handleTackStatusButton}
                    >Track Status</Button>
                  )}
                  <ListItemIcon onClick={() => { handleOpenShareJobDialog(); setResumeActionAnchorEl(null); }}>
                    <ShareIcon fontSize="extraLarge" sx={{ width: "24px !important", height: "24px !important", cursor: "pointer" }} />
                  </ListItemIcon>
                </Stack>
              </Box>
            )}
          </Stack>
        </Box>
        {loading ? (
          <Box className="header-bottom">
            <Skeleton height={40} width="40%" />
          </Box>
        ) : (
          application?.is_external_job_application && application?.status !== 'saved' && (
            <Box className="external-job-app">
              <Stack direction={{ sx: 'column', md: 'row' }} alignItems={{ xs: 'flex-start', md: 'center' }} justifyContent={'space-between'} sx={{ width: '100%' }} spacing={{ xs: 2.5, md: 0 }}>
                <Box>
                  <Typography className="ext-title">External Job Application</Typography>
                  <Typography className="ext-info-text">You can update application status using the dropdown on right hand side</Typography>
                </Box>
                <Box>
                  {application?.status === 'application pending' ? (
                    <Button variant="outlined" className="job-applied-btn" endIcon={
                      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                        <path d="M13.7802 5.9668L9.43355 10.3135C8.92021 10.8268 8.08021 10.8268 7.56688 10.3135L3.22021 5.9668" stroke="#1575C6" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    }
                      onClick={hadleOpenExtJobAppDialog}>
                      {changeNameFormat(applicationData?.status)}
                    </Button>
                  ) : (
                    <FormControl className="job-status-select" sx={{ borderRadius: '10px', backgroundColor: 'white', position: 'relative', minWidth: 140, zIndex: '9999' }} size="small">
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={applicationData?.status}
                        onChange={handleStatusChange}
                      >
                        <MenuItem value="applied">Applied</MenuItem>
                        <MenuItem value="shortlisted for interview">Shortlisted for interview</MenuItem>
                        <MenuItem value="final selection">Final selection</MenuItem>
                        <MenuItem value="offer made">Offer made</MenuItem>
                        <MenuItem value="offer accepted">Offer accepted</MenuItem>
                        <MenuItem value="joined firm">Joined firm</MenuItem>
                        <MenuItem value="not selected">Not selected</MenuItem>
                        <MenuItem value="offer declined">Offer declined</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                  <Typography className="updated-date" mt={0.5}>
                    {applicationData?.applied_at &&
                      `${applicationData.status === 'applied' ? 'Applied on' : 'Updated on'} ${dayjs(applicationData.status === 'applied' ? applicationData.applied_at : applicationData.updatedAt).format('DD MMM, YYYY')}`
                    }
                  </Typography>
                </Box>
              </Stack>
            </Box>
          ))}

        {loading ? (
          <Box className="header-bottom">
            <Skeleton height={40} width="40%" />
          </Box>
        ) : (
          <Box className="header-bottom my-internal-jobs">
            <Stack direction={{ sx: 'column', md: 'row' }} alignItems={'center'} justifyContent={'space-between'} sx={{ width: '100%' }} spacing={2}>
              <ToggleButtonGroup
                className="job-desc-toggle-btn"
                color="primary"
                value={alignment}
                exclusive
                onChange={handleToggleChange}
                aria-label="Platform"
                sx={{
                  width: (!['saved', 'application pending'].includes(application?.status) && isMobile && !application?.jobDetails?.external_link) ? '100%!important' : undefined
                }}
              >
                <ToggleButton value="job-overview" >Job Overview</ToggleButton>
                <ToggleButton value="job-desc" >Job Details</ToggleButton>
                {(application?.answers || application?.resume_data) && application?.status !== 'saved' && (
                  <ToggleButton value="job-application">Job Application</ToggleButton>
                )}
              </ToggleButtonGroup>
              {(applicationData?.status !== 'saved' && !application?.jobDetails?.external_link) && (
                <Box sx={{ textAlign: 'center' }}>
                  <Chip
                    className={`chip-job-status job-${(applicationData?.status === 'not selected' || application.status === 'not selected') ? 'rejected' : applicationData?.status || application.status}  `}
                    label={changeNameFormat(applicationData?.status || application.status)}
                    size="small"
                  />
                  <Typography className="updated-date">
                    {applicationData?.status !== 'saved' && applicationData?.applied_at ?
                      `${applicationData.status === 'applied' ? 'Applied on' : 'Updated on'} ${dayjs(applicationData.status === 'applied' ? applicationData.applied_at : applicationData.updatedAt).format('DD MMM, YYYY')}`
                      : getTimeDifferenceString(applicationData?.updatedAt, 'Updated')
                    }
                  </Typography>
                </Box>
              )}
            </Stack>
          </Box>
        )}
      </Box>

      {/* job overview block */}
      {loading ? (
        <Box className="job-full-overview">
          <Box className="job-overview-wrapper" mb={4}>
            <Card variant="outlined" className="requirements-match-card" sx={{ marginBottom: 3 }}>
              <CardContent>
                <Skeleton height={60} />
                <Skeleton height={40} width="60%" />
              </CardContent>
            </Card>
          </Box>
        </Box>
      ) : (
        <>
          <Box ref={jobFullOverviewRef} className="job-full-overview">
            <Box ref={jobOverviewRef} id="job-overview">
              <Box className="job-overview-wrapper" mb={4} >
                <Typography className="title">Job Overview</Typography>
                <Typography className="about-post-info" style={{ textAlign: 'justify', marginBottom: 15 }}>
                  {application?.jobDetails?.company_overview}
                </Typography>
                {isMobile ?
                  <Typography className="about-post-info" style={{ textAlign: 'justify' }}>
                    {truncatedDescription}
                    {application?.jobDetails?.job_overview.length > 50 && (
                      <span component="button" onClick={() => setShowMore(!showMore)}
                        style={{
                          textDecoration: 'underline',
                          color: 'var(--CTA-Active, #1575c6)',
                          cursor: 'pointer',
                        }}
                      >
                        {showMore ? 'Read less' : 'Read more'}
                      </span>
                    )}
                  </Typography>
                  : <Typography className="about-post-info" style={{ textAlign: 'justify' }}>{application?.jobDetails?.job_overview}
                  </Typography>}

                {application?.jobDetails?.overviews?.length > 0 &&
                  application?.jobDetails?.overviews?.map((item, index) => (
                    <List className="job-overview-list" sx={{ paddingTop: 0, paddingLeft: '1.5rem', listStyleType: 'disc' }}>
                      <ListItem sx={{ display: 'list-item' }} disablePadding key={application?._id}>
                        {item}
                      </ListItem>
                    </List>
                  ))}
              </Box>
            </Box>

            {/* Requirements Match Card */}
            <Card variant="outlined" className="requirements-match-card" sx={{ marginBottom: 3 }}>
              <CardContent>
                {
                  recommendedChip(application?.tj_score)}
                <Typography className="title">Requirements Match</Typography>
                <Typography className="info-text">
                  Matched against your educational background & work experience
                </Typography>
                <Box className="requirements-match" mt={1.5}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                      <Tooltip title={(application?.status === 'saved' || application?.status === 'application pending') ? `You have ${candidateDetails?.qualification?.join(', ')} education` : ''} arrow placement='top'>
                        <Box>
                          <Stack direction="row" align spacing={0.5}>
                            {(application?.status === 'saved' || application?.status === 'application pending') ?
                              requirementsMatch(application?.jobDetails?.qualifications || [], candidateDetails?.rating?.qualification, 'Qualification')
                              : requirementsMatch(application?.jobDetails?.qualifications || [], application?.candidate_score?.qualification, 'Qualification')}
                            <Box>
                              <Typography className="req-title" sx={{ marginTop: '-2px' }}>Required Education</Typography>
                              <Typography className="req-text">
                                {application?.jobDetails?.qualifications?.join(' | ')}
                              </Typography>
                            </Box>
                          </Stack>
                        </Box>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Tooltip title={(application?.status === 'saved' || application?.status === 'application pending') ? `You have ${candidateDetails?.totalExperience} years of experience.` : ''} arrow placement='top'>
                        <Box>
                          <Stack direction="row" spacing={0.5}>
                            {(application?.status === 'saved' || application?.status === 'application pending') ?
                              requirementsMatch(application?.jobDetails?.experience, candidateDetails?.rating?.experienceMatchRating, 'Experience')
                              : requirementsMatch(application?.jobDetails?.experience, application?.candidate_score?.experienceMatchRating, 'Experience')}
                            <Box>
                              <Typography className="req-title" sx={{ marginTop: '-2px' }}>Required Work Experience</Typography>
                              <Typography className="req-text">
                                {application?.jobDetails?.experience ? `${application?.jobDetails?.experience} Years` : 'N/A'}
                              </Typography>
                            </Box>
                          </Stack>
                        </Box>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Tooltip title={(application?.status === 'saved' || application?.status === 'application pending') ? (<>
                        {application?.jobDetails?.core_skills?.length > 0 ? (<div>Your preferred skills match = {percentage(coreMatchSkills.length, application?.jobDetails?.core_skills?.length)}%</div>) : ''}
                        <div>Your required skills match = {percentage(matchingSkills?.length, application?.jobDetails?.key_skills?.length)}%</div>
                      </>) : ''} arrow placement='top'>
                        <Box>
                          <Stack direction="row" spacing={0.5}>
                            {(application?.status === 'saved' || application?.status === 'application pending') ?
                              requirementsMatch(application?.jobDetails?.key_skills?.length || 0, candidateDetails?.rating?.skillMatchRating, 'Skills')
                              : requirementsMatch(application?.requirements?.matching_skills?.length || 0, application?.candidate_score?.skillMatchRating, 'Skills')}
                            <Box>
                              <Typography className="req-title" sx={{ marginTop: '-2px' }}>Required Skills</Typography>
                              <Typography className="req-text">
                                {application?.jobDetails?.core_skills?.length > 0 && (<>{coreMatchSkills.length || 0}/{application.jobDetails.core_skills.length} Preferred <br /></>)}
                                {matchingSkills?.length || 0}/{application?.jobDetails?.key_skills?.length || 0} Total
                              </Typography>
                            </Box>
                          </Stack>
                        </Box>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Tooltip title={(application?.status === 'saved' || application?.status === 'application pending') ? industryMessage() : ''} arrow placement='top'>
                        <Box>
                          <Stack direction="row" spacing={0.5}>
                            {(application?.status === 'saved' || application?.status === 'application pending') ?
                              requirementsMatch(application?.jobDetails?.industry_sector, candidateDetails?.rating?.industry, 'Industry')
                              : requirementsMatch(application?.jobDetails?.industry_sector, application?.candidate_score?.industry, 'Industry')}
                            <Box>
                              <Typography className="req-title" sx={{ marginTop: '-2px' }}>Industry Type</Typography>
                              <Typography className="req-text">{application?.jobDetails?.industry_sector || 'N/A'}</Typography>
                            </Box>
                          </Stack>
                        </Box>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Box>

                <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', marginTop: '1rem', marginBottom: '1rem' }} />

                <Box className="preferences-match">
                  <Typography className="title">Preferences Match</Typography>
                  <Typography className="pref-info-text" component="p">
                    Matched against your defined job preferences.{' '}
                    {(application?.status === 'saved' || application?.status === 'application pending') && (
                      <span style={{
                        textDecoration: 'underline',
                        color: 'var(--CTA-Active, #1575c6)',
                        cursor: 'pointer'
                      }}
                        onClick={handleOpenJobPreferenceDrawer}>
                        click here to update preferences
                      </span>
                    )}
                  </Typography>
                  <Box mt={2}>
                    <Stack spacing={1.5}>
                      <Grid container>
                        <Grid item xs={12} md={3}>
                          {matchIcon(
                            application?.jobDetails?.salary,
                            (application?.status === 'saved' || application?.status === 'application pending')
                              ? candidateDetails?.rating?.salaryMatchRating
                              : application?.candidate_score?.salaryMatchRating,
                            requirementMatchItem[0]
                          )}
                        </Grid>

                        <Grid item xs={12} md={9}>
                          <Box sx={{ marginLeft: { xs: '20px' } }}>
                            <Stack direction={{ xs: 'column', md: 'row' }} alignItems={'flex-start'} flexWrap="wrap" spacing={{ xs: 0, md: 0.7 }}>
                              {(application?.jobDetails?.is_compensation_confidential || !application?.jobDetails?.salary) ?
                                <Typography className="pref-match-info">Not Disclosed</Typography> : (<>
                                  <Typography className="pref-match-info">
                                    ₹{application?.jobDetails?.job_type === 'Full time' ? formatNumber(application?.jobDetails?.salary) : Intl.NumberFormat('en-IN').format(application?.jobDetails?.salary)}{' '}
                                    {application?.jobDetails?.job_type === 'Full time'
                                      ? application?.jobDetails?.compensation ? `(${application?.jobDetails?.compensation})` : ''
                                      : application?.jobDetails?.compensation_model === 'Fixed Fee' ? `(${application?.jobDetails?.compensation_model})` : application?.jobDetails?.compensation_model}
                                  </Typography>
                                </>)}
                              {(application?.status === 'saved' || application?.status === 'application pending') && application?.jobDetails?.salary && candidateDetails?.rating?.salaryMatchRating < 3 &&
                                <Typography className="pref-match-info notice-period-error">
                                  {salaryMessage(
                                    candidateDetails?.rating?.salaryMatchRating,
                                    candidateDetails?.user?.candidate?.job_preferences,
                                    application?.jobDetails?.salary,
                                    application?.jobDetails?.job_type
                                  )}
                                </Typography>
                              }
                            </Stack>
                          </Box>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={12} md={3}>
                          {matchIcon(
                            application?.jobDetails?.location,
                            (application?.status === 'saved' || application?.status === 'application pending')
                              ? candidateDetails?.rating?.location
                              : application?.candidate_score?.location,
                            requirementMatchItem[1]
                          )}
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <Box sx={{ marginLeft: { xs: '20px' } }}>
                            <Stack direction={{ xs: 'column', md: 'row' }} alignItems={'flex-start'} flexWrap="wrap" spacing={{ xs: 0, md: 0.7 }}>
                              <Typography className="pref-match-info" sx={{ flexShrink: 0 }}>
                                {(application?.jobDetails?.job_type !== 'Full time' &&
                                  application?.jobDetails?.work_mode === 'Work from Home' &&
                                  candidateDetails?.rating?.format === 2 &&
                                  candidateDetails?.rating?.location === 2)
                                  ? 'Remote'
                                  : (application?.jobDetails?.location || 'NA')
                                }
                              </Typography>
                              {(application?.status === 'saved' || application?.status === 'application pending') && candidateDetails?.rating?.location < 2 &&
                                <Typography className="pref-match-info notice-period-error">
                                  (Does not match any of your{' '}
                                  <Tooltip
                                    title={`Your preferred locations are ${candidateDetails?.user?.candidate?.job_preferences?.prefered_location?.join(', ')}`}
                                    arrow placement="top"
                                    open={(isMobile && openTooltip === 'location') ? openTooltip : undefined}
                                  >
                                    <span style={{ textDecoration: 'underline' }}
                                      onClick={() => handleToggleTooltip('location')}>
                                      preferred locations
                                    </span>
                                  </Tooltip>
                                  )
                                </Typography>
                              }
                            </Stack>
                          </Box>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={12} md={3}>
                          {matchIcon(
                            application?.jobDetails?.work_mode,
                            (application?.status === 'saved' || application?.status === 'application pending')
                              ? candidateDetails?.rating?.format
                              : application?.candidate_score?.format,
                            requirementMatchItem[2]
                          )}
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <Box sx={{ marginLeft: { xs: '20px' } }}>
                            <Stack direction={{ xs: 'column', md: 'row' }} alignItems={'flex-start'} flexWrap="wrap" spacing={{ xs: 0, md: 0.7 }}>
                              <Typography className="pref-match-info" sx={{ flexShrink: 0 }}>
                                {application?.jobDetails?.work_mode || 'NA'}
                              </Typography>
                              {(application?.status === 'saved' || application?.status === 'application pending') && candidateDetails?.rating?.format < 2 &&
                                <Typography className="pref-match-info notice-period-error">
                                  (Does not match any of your{' '}
                                  <Tooltip
                                    title={`Your preferred work formats is ${candidateDetails?.user?.candidate?.job_preferences?.work_format?.join(', ')}`}
                                    arrow placement="top"
                                    open={(isMobile && openTooltip === 'work_format') ? openTooltip : undefined}
                                  >
                                    <span style={{ textDecoration: 'underline' }}
                                      onClick={() => handleToggleTooltip('work_format')}>
                                      preferred job formats
                                    </span>
                                  </Tooltip>
                                  )
                                </Typography>
                              }
                            </Stack>
                          </Box>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={12} md={3}>
                          {matchIcon(
                            application?.jobDetails?.job_type,
                            (application?.status === 'saved' || application?.status === 'application pending')
                              ? candidateDetails?.rating?.type
                              : application?.candidate_score?.type,
                            requirementMatchItem[3]
                          )}
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <Box sx={{ marginLeft: { xs: '20px' } }}>
                            <Stack direction={{ xs: 'column', md: 'row' }} alignItems={'flex-start'} flexWrap="wrap" spacing={{ xs: 0, md: 0.7 }}>
                              <Typography className="pref-match-info" sx={{ flexShrink: 0 }}>
                                {application?.jobDetails?.job_type || 'NA'}
                              </Typography>
                              {(application?.status === 'saved' || application?.status === 'application pending') && candidateDetails?.rating?.type < 2 &&
                                <Typography className="pref-match-info notice-period-error">
                                  (Does not match any of your{' '}
                                  <Tooltip
                                    title={`Your preferred job type is ${candidateDetails?.user?.candidate?.job_preferences?.job_type?.join(', ')}`}
                                    arrow placement="top"
                                    open={(isMobile && openTooltip === 'job_type') ? openTooltip : undefined}
                                  >
                                    <span style={{ textDecoration: 'underline' }}
                                      onClick={() => handleToggleTooltip('job_type')}>
                                      preferred job types
                                    </span>
                                  </Tooltip>
                                  )
                                </Typography>
                              }
                            </Stack>
                          </Box>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs={12} md={3}>
                          {matchIcon(
                            application?.jobDetails?.job_shift,
                            (application?.status === 'saved' || application?.status === 'application pending')
                              ? candidateDetails?.rating?.shift
                              : application?.candidate_score?.shift,
                            requirementMatchItem[4]
                          )}
                        </Grid>
                        <Grid item xs={12} md={9}>
                          <Box sx={{ marginLeft: { xs: '20px' } }}>
                            <Stack direction={{ xs: 'column', md: 'row' }} alignItems={'flex-start'} flexWrap="wrap" spacing={{ xs: 0, md: 0.7 }}>
                              <Typography className="pref-match-info" sx={{ flexShrink: 0 }}>
                                {application?.jobDetails?.job_shift ? `${application?.jobDetails?.job_shift}` : 'NA'}
                              </Typography>
                              {(application?.status === 'saved' || application?.status === 'application pending') && candidateDetails?.rating?.shift < 2 &&
                                <Typography className="pref-match-info notice-period-error">
                                  (Does not match any of your{' '}
                                  <Tooltip
                                    title={`Your preferred job shift is ${candidateDetails?.user?.candidate?.job_preferences?.preferred_job_shifts?.join(', ')} as your preferred shift`}
                                    arrow placement="top"
                                    open={(isMobile && openTooltip === 'job_shift') ? openTooltip : undefined}
                                  >
                                    <span style={{ textDecoration: 'underline' }}
                                      onClick={() => handleToggleTooltip('job_shift')}>
                                      preferred shift
                                    </span>
                                  </Tooltip>
                                  )
                                </Typography>
                              }
                            </Stack>
                          </Box>
                        </Grid>
                      </Grid>
                      {application?.jobDetails?.job_type === 'Full time' ?
                        <Grid container>
                          <Grid item xs={12} md={3}>
                            {matchIcon(
                              application?.jobDetails?.notice_period,
                              (application?.status === 'saved' || application?.status === 'application pending')
                                ? candidateDetails?.rating?.notice
                                : application?.candidate_score?.notice,
                              requirementMatchItem[5]
                            )}
                          </Grid>
                          <Grid item xs={12} md={9}>
                            <Box sx={{ marginLeft: { xs: '20px' } }}>
                              <Stack direction={{ xs: 'column', md: 'row' }} alignItems={'flex-start'} flexWrap="wrap" spacing={{ xs: 0, md: 0.7 }}>
                                <Typography className="pref-match-info" sx={{ flexShrink: 0 }}>{application?.jobDetails?.notice_period ? ((application?.jobDetails?.notice_period === '0 days (immediate)' || application?.jobDetails?.notice_period === 'No preference') ? `${application?.jobDetails?.notice_period}` : `Upto ${application?.jobDetails?.notice_period} days`) : 'NA'}</Typography>
                                {(application?.status === 'saved' || application?.status === 'application pending') && candidateDetails?.rating?.notice < 2 &&
                                  <Typography className="pref-match-info notice-period-error">
                                    (Lower than your{' '}
                                    <Tooltip
                                      title={`Your current notice period is ${candidateDetails?.user?.candidate?.job_preferences?.notice_period} days`}
                                      arrow placement="top"
                                      open={(isMobile && openTooltip === 'notice_period') ? openTooltip : undefined}
                                    >
                                      <span style={{ textDecoration: 'underline' }}
                                        onClick={() => handleToggleTooltip('notice_period')}>
                                        current notice period
                                      </span>
                                    </Tooltip>
                                    )
                                  </Typography>
                                }
                              </Stack>
                            </Box>
                          </Grid>
                        </Grid> :
                        <Grid container>
                          <Grid item xs={12} md={3}>
                            {matchIcon(
                              application?.jobDetails?.weekly_time_commitment,
                              (application?.status === 'saved' || application?.status === 'application pending')
                                ? candidateDetails?.rating?.availableHour
                                : application?.candidate_score?.availableHour,
                              requirementMatchItem[6]
                            )}
                          </Grid>
                          <Grid item xs={12} md={9}>
                            <Box sx={{ marginLeft: { xs: '20px' } }}>
                              <Stack direction={{ xs: 'column', md: 'row' }} alignItems={'flex-start'} flexWrap="wrap" spacing={{ xs: 0, md: 0.7 }}>
                                <Typography className="pref-match-info" sx={{ flexShrink: 0 }}>
                                  {application?.jobDetails?.weekly_time_commitment}{' '} hours/ week, for {application?.jobDetails?.total_time_commitment_requirement}{' '} weeks, starting on{' '} {dayjs(application?.jobDetails?.start_date).format('MMM DD, YYYY')}
                                </Typography>
                                {(application?.status === 'saved' || application?.status === 'application pending') && candidateDetails?.rating?.availableHour < 2 &&
                                  <Typography className="pref-match-info notice-period-error">
                                    (Greater than your{' '}
                                    <Tooltip
                                      title={`Your current time commitment is ${candidateDetails?.user?.candidate?.job_preferences?.hour} hours per week`}
                                      arrow placement="top"
                                      open={(isMobile && openTooltip === 'hour') ? openTooltip : undefined}
                                    >
                                      <span style={{ textDecoration: 'underline' }}
                                        onClick={() => handleToggleTooltip('hour')}>
                                        time commitment
                                      </span>
                                    </Tooltip>
                                    )
                                  </Typography>
                                }
                              </Stack>
                            </Box>
                          </Grid>
                        </Grid>
                      }
                    </Stack>
                  </Box>
                </Box>
              </CardContent>
            </Card>

            <Card variant="outlined" className="skills-match-card" sx={{ marginBottom: 3 }}>
              <CardContent>
                <Box>
                  <Stack direction={{ xs: 'column', md: 'row' }} justifyContent={'space-between'}>
                    <Box>
                      <Typography className="title">Skills Match Analysis</Typography>
                    </Box>
                  </Stack>
                  <Typography className="info-text">
                    You possess {matchingSkills?.length || 0} present out{' '}
                    {application?.jobDetails?.key_skills?.length || 0} required skills. {''}
                    {(application?.status === 'saved' || application?.status === 'application pending') && (
                      <span style={{
                        textDecoration: 'underline',
                        color: 'var(--CTA-Active, #1575c6)',
                        cursor: 'pointer'
                      }}
                        onClick={handleOpenSkillsDrawer}>
                        click here to add missing skills
                      </span>
                    )}
                  </Typography>
                </Box>

                <Stack direction="row" alignItems={'center'} spacing={0.1} mb={2}>
                  <StarIcon className="star-icon" sx={{ width: '12px', color: '#faaf00', marginLeft: 'auto' }} />
                  <Typography sx={{
                    display: 'inline-flex',
                    color: '#374151',
                    fontFamily: '"Inter", sans-serif',
                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    lineHeight: '18px',
                    margin: '0 5px!important'
                  }}>Denote preferred skills</Typography>

                  <Tooltip title={`For success in this job, these skills are considered to be the most important`} arrow placement="top" >
                    <SvgIcon sx={{ width: '12px' }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M0 6C0 9.30764 2.69236 12 6 12C9.30764 12 12 9.30764 12 6C12 2.69236 9.30764 0 6 0C2.69236 0 0 2.69236 0 6ZM6 1.09091C8.70764 1.09091 10.9091 3.29236 10.9091 6C10.9091 8.70764 8.70764 10.9091 6 10.9091C3.29236 10.9091 1.09091 8.70764 1.09091 6C1.09091 3.29236 3.29236 1.09091 6 1.09091Z" fill="#1575C6" />
                        <path d="M6.00004 8.74382C6.30114 8.74382 6.5455 8.49946 6.5455 8.19837V5.41655C6.5455 5.11546 6.30114 4.87109 6.00004 4.87109C5.69895 4.87109 5.45459 5.11546 5.45459 5.41655V8.19837C5.45459 8.49946 5.69895 8.74382 6.00004 8.74382Z" fill="#1575C6" />
                        <path d="M6.00004 4.34599C6.03495 4.34599 6.07204 4.34163 6.10695 4.33508C6.14186 4.32853 6.17677 4.31763 6.2095 4.30453C6.24223 4.29144 6.27277 4.27399 6.30332 4.25435C6.33168 4.23472 6.36004 4.21072 6.38623 4.18672C6.48659 4.08417 6.5455 3.94453 6.5455 3.80053C6.5455 3.65653 6.48659 3.5169 6.38623 3.41435C6.25968 3.28781 6.06986 3.23108 5.89313 3.26599C5.85823 3.27253 5.82332 3.28344 5.79059 3.29653C5.75786 3.30963 5.72732 3.32708 5.69677 3.34672C5.66841 3.36635 5.64004 3.39035 5.61386 3.41435C5.5135 3.5169 5.45459 3.65653 5.45459 3.80053C5.45459 3.94453 5.5135 4.08417 5.61386 4.18672C5.71641 4.28708 5.85604 4.34599 6.00004 4.34599Z" fill="#1575C6" />
                      </svg>
                    </SvgIcon>
                  </Tooltip>
                </Stack>

                <Stack direction="row" flexWrap="wrap" sx={{ marginBottom: '1rem' }} >
                  {application?.jobDetails?.key_skills
                    ? application?.jobDetails?.key_skills.map((skill, index) => (
                      <Chip
                        key={index}
                        icon={
                          matchingSkills?.includes(skill) ? (
                            <Box className="match-icon">
                              <SvgIcon>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.83402 1.78254L2.59366 5.0229C2.37351 5.24305 2.00888 5.24305 1.78185 5.0229L0.165114 3.40616C-0.0550379 3.18601 -0.0550379 2.82138 0.165114 2.59435C0.385265 2.3742 0.749891 2.3742 0.976923 2.59435L2.19464 3.81207L5.02909 0.977614C5.24924 0.757462 5.61386 0.757462 5.8409 0.977614C6.05417 1.19777 6.05417 1.56239 5.83402 1.78254Z" fill="white" />
                                </svg>
                              </SvgIcon>
                            </Box>
                          ) : (
                            <Box className="error-match-icon">
                              <SvgIcon>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="6"
                                  height="6"
                                  viewBox="0 0 6 6"
                                  fill="none"
                                >
                                  <path
                                    d="M0.134092 5.23008L2.36417 3L0.134092 0.769922C0.0918098 0.728272 0.0581919 0.678662 0.0351778 0.623955C0.0121637 0.569247 0.000208773 0.510524 2.71012e-06 0.451173C-0.000203353 0.391823 0.0113435 0.333018 0.0339772 0.278152C0.0566109 0.223286 0.0898834 0.173444 0.131876 0.131501C0.173868 0.0895583 0.223749 0.0563443 0.278642 0.0337753C0.333535 0.0112063 0.392353 -0.000271149 0.451703 4.86231e-06C0.511054 0.000280873 0.569763 0.0123049 0.624443 0.0353835C0.679123 0.0584621 0.728693 0.0921385 0.770294 0.13447L2.99962 2.36455L5.2297 0.13447C5.2713 0.0921385 5.32087 0.0584621 5.37555 0.0353835C5.43023 0.0123049 5.48894 0.000280873 5.54829 4.86231e-06C5.60764 -0.000271149 5.66646 0.0112063 5.72135 0.0337753C5.77624 0.0563443 5.82613 0.0895583 5.86812 0.131501C5.91011 0.173444 5.94338 0.223286 5.96602 0.278152C5.98865 0.333018 6.0002 0.391823 5.99999 0.451173C5.99978 0.510524 5.98783 0.569247 5.96482 0.623955C5.9418 0.678662 5.90818 0.728272 5.8659 0.769922L3.63507 3L5.86515 5.23008C5.90743 5.27173 5.94105 5.32134 5.96407 5.37605C5.98708 5.43075 5.99904 5.48948 5.99924 5.54883C5.99945 5.60818 5.9879 5.66698 5.96527 5.72185C5.94263 5.77671 5.90936 5.82656 5.86737 5.8685C5.82538 5.91044 5.7755 5.94366 5.7206 5.96622C5.66571 5.98879 5.60689 6.00027 5.54754 6C5.48819 5.99972 5.42948 5.9877 5.3748 5.96462C5.32012 5.94154 5.27055 5.90786 5.22895 5.86553L2.99962 3.63545L0.769545 5.86553C0.685044 5.94877 0.571075 5.99524 0.452464 5.99483C0.333852 5.99442 0.220209 5.94715 0.136288 5.86333C0.0523672 5.77951 0.00496864 5.66592 0.00441704 5.54731C0.00386544 5.4287 0.0502055 5.31468 0.133343 5.23008H0.134092Z"
                                    fill="white"
                                  />
                                </svg>
                              </SvgIcon>
                            </Box>
                          )
                        }
                        label={
                          application?.jobDetails?.core_skills?.includes(skill) ?
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                              <StarIcon className="star-icon" sx={{ color: '#faaf00', padding: '5px', marginLeft: 'auto' }} />
                              <span>{skill}</span>
                            </Box> : skill
                        }
                        variant="outlined"
                        className={matchingSkills?.includes(skill) ? 'match-skill' : 'destructive-skill'}
                      />
                    ))
                    : 'No Skills'}
                </Stack>
              </CardContent>
            </Card>

            <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', marginTop: '1rem', marginBottom: '1rem' }} />

            <Box sx={{ marginBottom: { xs: 'calc(100vh - 90vh)', sm: 'calc(100vh - 90vh)', md: 'calc(100vh - 52vh)', lg: 'calc(100vh - 52vh)' } }}>
              {/* description */}
              <Box ref={jobDescRef} id="job-desc" className="job-description my-job" sx={{ marginBottom: '0px!important' }}>
                <Typography className="title">Job Details</Typography>
                <Typography className="info-text list-style">
                  <div dangerouslySetInnerHTML={{ __html: application?.jobDetails?.description }} />
                </Typography>
              </Box>

              {/* questions */}
              {(application?.answers || application?.resume_data) && application?.status !== 'saved' && (
                <Box>

                  <Divider sx={{ borderStyle: 'dashed', borderWidth: '1px', marginTop: '1rem', marginBottom: '1rem' }} />

                  <Box ref={jobApplicationRef} id="job-application" className="job-application">
                    <Typography className="title">Job Application</Typography>
                    {application?.jobDetails?.external_link ? (
                      application?.jobDetails?.question && application?.jobDetails?.question.length > 0 && (
                        <>
                          <Typography className="info-text">
                            Your response to the screening questions & resume you applied with
                          </Typography>

                          <List className="job-application-list" sx={{ marginTop: '1rem', paddingTop: 0, paddingLeft: '1.5rem', listStyle: "decimal" }}>
                            {application?.jobDetails?.question.map((qus, index) => (
                              <ListItem sx={{ display: 'list-item' }} disablePadding key={index}>
                                <Typography className="questions-text">{qus}</Typography>
                              </ListItem>
                            ))}
                          </List>
                        </>
                      )
                    ) : (
                      application?.answers && Object.keys(application?.answers).length > 0 && (
                        <>
                          <Typography className="info-text">
                            Your response to the screening questions & resume you applied with
                          </Typography>

                          <List
                            className="job-application-list"
                            sx={{ marginTop: '1rem', paddingTop: 0, paddingLeft: '1.5rem', listStyle: 'decimal' }}
                          >
                            {Object.entries(application?.answers).map(([key, value]) => (
                              <ListItem sx={{ display: 'list-item' }} disablePadding key={key}>
                                <Typography className="questions-text">{key}</Typography>
                                <Typography className="answer-text">{value}</Typography>
                              </ListItem>
                            ))}
                          </List>
                        </>
                      )
                    )}
                  </Box>
                </Box>
              )}

              {!(application?.jobDetails?.external_link) && (application?.status !== 'saved' && application?.status !== 'Not Applied') && (
                <Box className="applied-resume-date-info">
                  <Stack direction="row" alignItems={'center'} justifyContent={'space-between'} spacing={2}>
                    <Typography className="info-text">
                      You applied with {application?.resume_data?.title} for this job on{' '}
                      {dayjs(application?.applied_at).format('DD MMM, YYYY')}
                    </Typography>
                    {/* <Link sx={{ cursor: 'pointer', textDecoration: 'underline !important' }} onClick={handleOpenResumeViewer}>View Resume</Link> */}
                    <span style={{
                      textDecoration: 'underline',
                      color: 'var(--CTA-Active, #1575c6)',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: 700
                    }}
                      onClick={handleOpenResumeViewer}>
                      View Resume
                    </span>
                  </Stack>
                  <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={2} pt={1}>
                    {!isDocResume && (
                      <Tooltip title="Download PDF Resume" arrow>
                        <PictureAsPdfIcon
                          className="download-resume"
                          onClick={isUploadedResume ? handleDownloadUploadedResume : handlePDFDownloadResume}
                          sx={{ color: "#1575c6", display: "flex", alignItems: "center", cursor: "pointer" }}
                        />
                      </Tooltip>
                    )}

                    {(isDocResume !== "" && (isDocResume || !isUploadedResume)) && (
                      <Tooltip title="Download Word Resume" arrow>
                        <DescriptionIcon
                          className="download-resume"
                          onClick={handleDownloadWordResume}
                          sx={{ color: "#1575c6", display: "flex", alignItems: "center", cursor: "pointer" }}
                        />
                      </Tooltip>
                    )}
                  </Stack>
                </Box>
              )}

            </Box>
          </Box>
          <Box sx={{ display: { xs: 'block', md: 'none' } }} padding={1}>
            <Stack direction="row" alignItems={'center'} spacing={2}>
              {application?.status === 'saved' && (
                <Button
                  variant="outlined"
                  size="large"
                  className="saved-btn"
                  onClick={handleOpenAutoUnsaveDialog}
                  fullWidth
                  startIcon={
                    <SvgIcon >
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 6 6" fill="none">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.77869 1.3764L3.45821 5.69687C3.16468 5.99041 2.67851 5.99041 2.3758 5.69687L0.220152 3.54122C-0.0733838 3.24769 -0.0733838 2.76152 0.220152 2.45881C0.513687 2.16527 0.999855 2.16527 1.30256 2.45881L2.92618 4.08243L6.70545 0.303159C6.99898 0.00962395 7.48515 0.00962395 7.78786 0.303159C8.07222 0.596695 8.07222 1.08286 7.77869 1.3764Z"
                          fill="white"
                        />
                      </svg>
                    </SvgIcon>
                  }
                >
                  Job Saved
                </Button>
              )}
              {(application?.status === 'saved' || application?.status === 'application pending') &&
                <Button
                  variant="contained"
                  size="large"
                  className={application?.jobDetails?.external_link ? "external-apply-now-btn" : "apply-now-btn"}
                  endIcon={application?.jobDetails?.external_link ? < SvgIcon >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5413 0.0581763C15.7159 0.130897 15.8613 0.276338 15.934 0.450867H15.9413C15.9776 0.538131 15.9995 0.632668 15.9995 0.727205V5.03953C15.9995 5.43949 15.6722 5.76673 15.2723 5.76673C14.8723 5.76673 14.5451 5.43949 14.5451 5.03953V2.47977L8.51653 8.50829C8.37109 8.64646 8.18929 8.71918 8.00021 8.71918C7.81114 8.71918 7.62934 8.65373 7.4839 8.50829C7.20029 8.22468 7.20029 7.76654 7.4839 7.48293L13.5124 1.45441H10.9527C10.5527 1.45441 10.2255 1.12717 10.2255 0.727205C10.2255 0.327242 10.5527 0 10.9527 0H15.265C15.3595 0 15.4541 0.0218161 15.5413 0.0581763ZM14.5375 8.0013C14.5375 7.60134 14.8648 7.27409 15.2648 7.27409C15.6647 7.27409 15.992 7.60134 15.992 8.0013V13.0554C15.992 14.677 14.6684 16.0005 13.0468 16.0005H2.94591C1.32424 16.0005 0.000732422 14.677 0.000732422 13.0554V2.9545C0.000732422 1.33283 1.32424 0.00932173 2.94591 0.00932173H7.99998C8.39994 0.00932173 8.72719 0.336564 8.72719 0.736526C8.72719 1.13649 8.39994 1.46373 7.99998 1.46373H2.94591C2.12417 1.46373 1.45514 2.13276 1.45514 2.9545V13.0554C1.45514 13.8771 2.12417 14.5461 2.94591 14.5461H13.0468C13.8685 14.5461 14.5375 13.8771 14.5375 13.0554V8.0013Z" fill="white" />
                    </svg>
                  </SvgIcon> : null}
                  onClick={handleApplyJob}
                  fullWidth
                >
                  Apply Now
                </Button>
              }
              <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <IconButton
                  aria-label="more"
                  aria-controls={openActionMenu ? 'resume-action-menu' : undefined}
                  aria-expanded={openActionMenu ? 'true' : undefined}
                  aria-haspopup="true"
                  onClick={(event) => setResumeActionAnchorEl(event.currentTarget)}
                  className="resume-action-menu-btn"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="20" viewBox="0 0 4 20" fill="none">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2 4C0.895431 4 5.79551e-07 3.10457 6.27833e-07 2C6.76115e-07 0.89543 0.895431 -1.35705e-07 2 -8.74228e-08C3.10457 -3.91405e-08 4 0.89543 4 2C4 3.10457 3.10457 4 2 4ZM2 12C0.895431 12 7.06698e-07 11.1045 7.54981e-07 9.99997C8.03263e-07 8.8954 0.895431 7.99997 2 7.99997C3.10457 7.99997 4 8.8954 4 9.99997C4 11.1045 3.10457 12 2 12ZM8.82124e-07 18C8.33842e-07 19.1046 0.895431 20 2 20C3.10457 20 4 19.1046 4 18C4 16.8955 3.10457 16 2 16C0.895431 16 9.30406e-07 16.8955 8.82124e-07 18Z"
                      fill="#1575C6"
                    />
                  </svg>
                </IconButton>
              </Box>
              <Menu
                id="resume-action-menu"
                className="resume-action-menu"
                anchorEl={resumeActionAnchorEl}
                open={openActionMenu}
                onClose={() => setResumeActionAnchorEl(null)}
                sx={{ marginTop: 2 }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <MenuItem onClick={() => { handleOpenShareJobDialog(); setResumeActionAnchorEl(null); }}>
                  Share Job
                </MenuItem>
              </Menu>
            </Stack>
            {application?.is_external_job_application && application?.status !== 'saved' && application?.status !== 'application pending' &&
              <Box className="job-details-track-bottom">
                <Button variant="outlined" size="large" fullWidth className="external-apply-now-btn" endIcon={<SvgIcon>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5413 0.0581763C15.7159 0.130897 15.8613 0.276338 15.934 0.450867H15.9413C15.9776 0.538131 15.9995 0.632668 15.9995 0.727205V5.03953C15.9995 5.43949 15.6722 5.76673 15.2723 5.76673C14.8723 5.76673 14.5451 5.43949 14.5451 5.03953V2.47977L8.51653 8.50829C8.37109 8.64646 8.18929 8.71918 8.00021 8.71918C7.81114 8.71918 7.62934 8.65373 7.4839 8.50829C7.20029 8.22468 7.20029 7.76654 7.4839 7.48293L13.5124 1.45441H10.9527C10.5527 1.45441 10.2255 1.12717 10.2255 0.727205C10.2255 0.327242 10.5527 0 10.9527 0H15.265C15.3595 0 15.4541 0.0218161 15.5413 0.0581763ZM14.5375 8.0013C14.5375 7.60134 14.8648 7.27409 15.2648 7.27409C15.6647 7.27409 15.992 7.60134 15.992 8.0013V13.0554C15.992 14.677 14.6684 16.0005 13.0468 16.0005H2.94591C1.32424 16.0005 0.000732422 14.677 0.000732422 13.0554V2.9545C0.000732422 1.33283 1.32424 0.00932173 2.94591 0.00932173H7.99998C8.39994 0.00932173 8.72719 0.336564 8.72719 0.736526C8.72719 1.13649 8.39994 1.46373 7.99998 1.46373H2.94591C2.12417 1.46373 1.45514 2.13276 1.45514 2.9545V13.0554C1.45514 13.8771 2.12417 14.5461 2.94591 14.5461H13.0468C13.8685 14.5461 14.5375 13.8771 14.5375 13.0554V8.0013Z" fill="white" />
                  </svg>
                </SvgIcon>}
                  onClick={handleTackStatusButton}
                >Track Status</Button>
              </Box>
            }
          </Box>
        </>
      )}

      {/* apply now chatboat drawer */}
      <Drawer
        open={openChatBotDrawer}
        className="chat-bot-drawer-dialog"
        anchor={'right'}
        onClose={toggleChatBotDrawer(false)}
      >
        <ChatBotDrawer
          questions={application?.jobDetails?.question}
          onClose={toggleChatBotDrawer(false)}
          onSelected={handleSelectedResume}
          tab={'3'}
          data={application}
          candidateDetails={candidateDetails}
          matchingSkills={matchingSkills}
          handleCloseDrawer={handleCloseDrawer}
          isPartTimeJob={application?.jobDetails?.job_type.toLowerCase() == 'full time' ? false : true}
          onUpdatePreference={handleUpdatePreference}
        />
      </Drawer>

      {/* update job preferences drawer */}
      <Drawer open={openJobPreference} anchor={'right'} onClose={handleCloseJobPreferenceDrawer}>
        <JopApplicationDrawer
          onClose={handleCloseJobPreferenceDrawer}
          data={candidateDetails?.user?.candidate?.job_preferences}
          onUpdatePreference={handleUpdatePreference}
        />
      </Drawer>

      {/* update relevent skills drawer */}
      <Drawer open={openSkillsDrawer} anchor={'right'} onClose={handleCloseSkillsDrawer}>
        <UpdateReleventSkillsDrawer
          onClose={handleCloseSkillsDrawer}
          workExperience={candidateDetails?.workHistory}
          education={candidateDetails?.educations}
          certificate={candidateDetails?.certificate}
          skillsUpdate={handleSkillsUpdate}
          nonMatchingSkills={nonMatchingSkills}
          matchingSkills={matchingSkills}
          setNonMatchingSkills={handleNonMatchingSkills}
        />
      </Drawer>

      {/* auto save job app dialog */}
      <Dialog
        open={autoSaveDialogOpen}
        onClose={handleCloseAutoSaveDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="auto-save-app-dialog"
      >
        <AutoSavingJobAppDialog />
      </Dialog>

      {/* resume preview */}
      <Dialog open={openResumeViewer} onClose={handleCloseResumeViewer} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" className="full-view-resume-dialog">
        <Box className="resume-container" sx={{ borderRadius: '0px' }}>
          <div className="pdf-container" style={{ position: 'relative', height: '80vh', width: '100%', overflowY: 'auto' }}>
            {isUploadedResume ?
              <>
                <Worker workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`} />
                <Viewer fileUrl={process.env.REACT_APP_END_POINT + isUploadedResume} />
              </> :
              <PDFViewer pdfData={resumePDF} width={isMobile ? window.innerWidth * 0.8 : ''} />}
          </div>
        </Box>
      </Dialog>

      {/* external job and download resume dialog */}
      {
        isMobile ? (
          <Drawer
            anchor="bottom"
            open={openExternalJob}
            onClose={handleCloseExternalJobDialog}
            className="mobile-bottomsheet-dialog action-dialog-card external-job-app-dialog"
          >
            <ExternalJob onClose={handleCloseExternalJobDialog} externalJobStatus={handleExternalJobStatus} downloadResume={handleDownloadResume} job={application} tab={'3'} candidateDetails={candidateDetails} matchingSkills={matchingSkills} />
          </Drawer>) : (
          <Dialog
            open={openExternalJob}
            onClose={handleCloseExternalJobDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="action-dialog-card external-list-dialog"
          > <DialogContent>
              <ExternalJob onClose={handleCloseExternalJobDialog} externalJobStatus={handleExternalJobStatus} downloadResume={handleDownloadResume} job={application} tab={'3'} candidateDetails={candidateDetails} matchingSkills={matchingSkills} />
            </DialogContent>
          </Dialog>
        )
      }

      {/* external job status */}
      {
        isMobile ? (
          <Drawer
            anchor="bottom"
            open={openExternalJobStatus}
            onClose={handleCloseExternalJobStatusDialog}
            className="mobile-bottomsheet-dialog action-dialog-card external-job-app-dialog"
          >
            <ExternalJobStatus onClose={handleCloseExternalJobStatusDialog} job={application} tab={'3'} candidateDetails={candidateDetails} matchingSkills={matchingSkills} />
          </Drawer>) : (
          <Dialog
            open={openExternalJobStatus}
            onClose={handleCloseExternalJobStatusDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="action-dialog-card external-list-dialog"
          > <DialogContent>
              <ExternalJobStatus onClose={handleCloseExternalJobStatusDialog} job={application} tab={'3'} candidateDetails={candidateDetails} matchingSkills={matchingSkills} />
            </DialogContent>
          </Dialog>
        )
      }
      {/* External job application dialog */}
      {
        isMobile ? (
          <Drawer
            anchor="bottom"
            open={extJobAppDialogOpen}
            onClose={handleCloseExtJopAppDialog}
            className="forgot-password-dialog"
          >
            <ExternalJobApplicationDialog onClose={handleCloseExtJopAppDialog} externalJobStatus={handleExternalJobStatus} downloadResume={handleDownloadResume} jobId={application?.job_id} jobDetails={application?.jobDetails} tj_score={application?.tj_score} handleRefetchJob={handleRefetchJob} />
          </Drawer>) : (
          <Dialog
            open={extJobAppDialogOpen}
            onClose={handleCloseExtJopAppDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="external-job-app-dialog"
          >
            <ExternalJobApplicationDialog onClose={handleCloseExtJopAppDialog} externalJobStatus={handleExternalJobStatus} downloadResume={handleDownloadResume} jobId={application?.job_id} jobDetails={application?.jobDetails} tj_score={application?.tj_score} handleRefetchJob={handleRefetchJob} />
          </Dialog>
        )
      }
      {/* unsaved job */}
      {
        isMobile ? (
          <Drawer
            anchor="bottom"
            open={autoUnsaveDialogOpen}
            onClose={handleCloseAutoUnsaveDialog}
            className="mobile-bottomsheet-dialog action-dialog-card external-job-app-dialog">
            <UnsaveCard onClose={handleCloseAutoUnsaveDialog} onUnsave={handleUnsaveJob} title={application?.jobDetails?.title} />
          </Drawer>) : (
          <Dialog
            open={autoUnsaveDialogOpen}
            onClose={handleCloseAutoUnsaveDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="action-dialog-card external-list-dialog"
          > <DialogContent>
              <UnsaveCard onClose={handleCloseAutoUnsaveDialog} onUnsave={handleUnsaveJob} title={application?.jobDetails?.title} />
            </DialogContent>
          </Dialog>)
      }

      {
        isMobile ?
          <Drawer
            anchor="bottom"
            open={shareJobDialogOpen}
            onClose={handleCloseShareJobDialog}
            className="forgot-password-dialog"
          >
            <ShareJob jobId={application?.jobDetails?.jobid} onClose={handleCloseShareJobDialog} />
          </Drawer> :
          <Dialog
            open={shareJobDialogOpen}
            onClose={handleCloseShareJobDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="external-job-app-dialog"
          >
            <ShareJob jobId={application?.jobDetails?.jobid} onClose={handleCloseShareJobDialog} />
          </Dialog>
      }
    </Box >
  );
};

export default JobFullDetails;
